export default __webpack_public_path__ + "static/media/b.1f64c517.png";